export default "__VITE_ASSET__BUhN3Y6O__"